import { render, staticRenderFns } from "./PropertiesCardTemplate.vue?vue&type=template&id=51137962"
import script from "./PropertiesCardTemplate.vue?vue&type=script&lang=js"
export * from "./PropertiesCardTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports